module.exports = __webpack_public_path__ + "static/img/equip-2.b8a9ff10.png";